require('./bootstrap');

require('jquery-ui');
import inputmask from "inputmask/lib/jquery.inputmask";

import $ from 'jquery';

//$.inputmask = inputmask

window.$ = window.jQuery = $;


var landing = {
    host: '',
    protocol: '',
    data: {},
    selectors: {
        get inputSubdomain() {
            return '#subdomain';
        },
        get popupEnter() {
            return '#enter';
        },
        get tryForm() {
            return '#try-form';
        }
    },
    init: function () {
        var that = this;
        window.landing = that;
        that.host = window.location.host;
        that.protocol = window.location.protocol;

        that.phoneMask();
        //that.topSticky('#top');
        that.changePrice();
        that.changePriceHelper(416, 890, 1690, 'При оплате за 12 месяцев');
        that.openModal();

        $(that.selectors.popupEnter).on('opened', function () {
            that.popupEnterOpened();
        });

        $(that.selectors.inputSubdomain).on('keyup', function (e) {
            if (e.which == 13) {
                that.goSubdomain();
            }
        });
        $(that.selectors.tryForm).on('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let form = new FormData(this);
            axios({
                method: 'post',
                url: '/client/ajax',
                data: form,
                //headers: {'X-CSRF-Token': $('meta[name="_token"]').attr('content')}
            })
                .then(function (e) {
                    if (!e.data.error) {
                        let name = e.data.name;
                        let phone = e.data.phone;
                        open('https://get.target-rest.ru/auth/add/?name=' + name + '&phone=' + phone, '_blank')
                    }
                })

        });

        /*
        $("#sign-in-modal-form").validate({
            focusInvalid: false,
            errorClass: 'error',
            rules: {
                name: {
                    required: true,
                    remote: {
                        url: "/auth/existsmanufacture",
                        beforeSend: function() {
                            $('#subdomain').addClass('preloader');
                        },
                        type: "post",
                        complete: function() {
                            $('#subdomain').removeClass('preloader');
                        }
                    }
                },
            },
            messages: {
                name: {
                    required: "Укажите поддомен",
                    remote: "Такого производства нет в нашей базе",
                }
            },
            submitHandler: function(form) {
                var subdomain = $('#subdomain').val();
                window.location.href = 'https://' + subdomain + '.p.flylunch.ru';
            },
        });

         */
    },
    scroll: function () {
        $(".top .links").on("click", "a", function (event) {
            if($(this).data('link')){
                return
            }
            event.preventDefault();
            var id = $(this).attr('href');
            var href = $(this).data('href');

            id = id.replace('/', '');
            window.landing.handler(id, 70);
        });
    },

    openModal: function () {
        var myHash = location.hash; //получаем значение хеша
        location.hash = ''; //очищаем хеш

        if (myHash[1] != undefined && myHash == '#rec234004274') {
            $('#registrationModal').modal('show');
        }
        ;
        if (myHash[1] != undefined && myHash == '#rec234004275') {
            $('#sign-in-modal').modal('show');
        }
        ;
        location.hash = myHash; //устанавливаем хеш
    },

    scrollP: function () {
        var myHash = location.hash; //получаем значение хеша l
        location.hash = ''; //очищаем хеш
        if (myHash[1] != undefined) { //проверяем, есть ли в хеше какое-то значение
            window.landing.handler(myHash, 140);
        }
        ;
        location.hash = myHash; //устанавливаем хеш
    },
    handler: function (id, px) {
        if ($(id).length > 0) {
            var top = $(id).offset().top;
            $('body,html').animate({scrollTop: top - px}, 1500);
            location.hash = id;
        }
    },
    goSubdomain: function () {
        var val = $(this.selectors.inputSubdomain).val();
        if (!val) {
            alert('Укажите поддомен');
            return false;
        }
        window.location.href = 'https://' + val + '.p.flylunch.ru';
    },
    popupEnterOpened: function () {
        $(this.selectors.inputSubdomain).focus();
    },
    popupOpen: function (id) {
        $('#' + id).addClass('open').trigger('opened');
    },
    popupClose: function (id) {
        $('#' + id).removeClass('open');
    },
    activateButton: function ($this) {
        $(this).parent().children("button").removeClass('active');
        $(this).addClass('cative');
    },
    phoneMask: function () {
        $("#form-phone").inputmask("999 999-99-99", {showMaskOnFocus: false, showMaskOnHover: false});
        $("#modal-phone").inputmask("999 999-99-99", {showMaskOnFocus: false, showMaskOnHover: false});
        $("#modal-phone2").inputmask("999 999-99-99", {showMaskOnFocus: false, showMaskOnHover: false});
    },
    /*
    topSticky: function(selector) {
        $(selector).scroolly([
            {
                from: 'con-top',
                to: 'con-top + 250 = top',
                css: {
                    position: 'fixed',
                    top: '0px',
                    'min-width': '100%',
                    bottom: '',
                    opacity: 0,
                    visibility: 'hidden'
                }
            },
            {
                from: 'con-top + 250 = top',
                to: 'con-bottom = top',
                css: {
                    position: 'fixed',
                    top: '0px',
                    bottom: '',
                    'min-width': '100%',
                    opacity: 1,
                    transition: '.35s',
                    visibility: 'visible'
                },

            },
        ], $('body'));
    },

     */
    changePriceHelper: function (base, basePlus, pro, message) {
        $('.base-price').html(base);
        $('.base-plus-price').html(basePlus);
        $('.pro-price').html(pro);
        $('.tarif-1-price').html(base);
        $('.tarif-2-price').html(basePlus);
        $('.tarif-4-price').html(pro);
        $('.price-message').html(message);
    },
    changePrice: function () {
        $('.btn-change-price').on('click', function () {
            switch ($(this).data('round')) {
                case 1:
                    window.landing.changePriceHelper(590, 1500, 2300, '');
                    ;
                    $('.price-message').hide();
                    break;
                // case 3:
                //     window.landing.changePriceHelper(1430, 4280, 8100, 'При оплате за 3 месяца');
                //     $('.price-message').show();
                //     break;
                // case 6:
                //     window.landing.changePriceHelper(1380, 4150, 7815, 'При оплате за 6 месяцев');
                //     $('.price-message').show();
                //     break;
                case 12:
                    window.landing.changePriceHelper(416, 890, 1690, 'При оплате за 12 месяцев');
                    $('.price-message').show();
                    break;
            }
        })
    },
    addListeners: function () {

    }

}.init();

var registration = {
    handler: 0,
    countryCodeData: {
        'ru': {
            code: '+7',
            numberCount: '10',
            mask: '999 999-99-99',
            placeholder: '912 238-18-58',
            flagURL: '',
        },

        'kz': {
            code: '+7',
            numberCount: '10',
            mask: '999 999-99-99',
            placeholder: '771 000-99-98',
        },

        'ua': {
            code: '+380',
            numberCount: '9',
            mask: '99 999-99-99',
            placeholder: '39 123-45-67',
        },

        'by': {
            code: '+375',
            numberCount: '9',
            mask: '99 999-99-99',
            placeholder: '22 491-19-11',
        },

        'uz': {
            code: '+998',
            numberCount: '9',
            mask: '99 999-99-99',
            placeholder: '91 234-56-78',
            flagURL: '',
        },

        'af': {
            code: '+93',
            numberCount: '9',
            mask: '99 999-99-99',
            placeholder: '70 123-45-67',
        }
    },

    init: function () {
        var that = this;
        window.registration = that;
        that.onInputEvent();
        that.initCoockie();
        //that.validate();
        that.selectCodePhone();
        that.checkmanufactureName();
        that.openRegistrationModal();

        // that.filterManufacture();

        that.targetsToggle();

        if (localStorage.getItem('client-country-code') == null) {
            localStorage.setItem('client-country-code', 'ru')
        }

        window.registration.phoneCodeChange("#modal-phone", localStorage.getItem('client-country-code'));
        window.registration.phoneCodeChange("#form-phone", localStorage.getItem('client-country-code'));
    },

    openRegistrationModal: function () {
        $('.btn-try-free').on('click', function (event) {
            event.preventDefault();
            $('body').css('padding-right', '0px');
            $('#registrationModal').css('padding-right', '0px');
            $('#registrationModal').modal('show');
            window.registration.checkmanufactureName();
        })
    },

    initCoockie: function () {
        var phoneInputForm = $('#modal-phone'),
            nameInputForm = $('.modal-name'),
            formName = $('#form-name'),
            formPhone = $('#form-phone'),
            email = $('#email-modal'),
            manufacture = $('#manufacture_name'),
            manufactureHidden = $('#manufacture_name-hidden'),
            phoneCode = $('.phone-code');

        phoneInputForm.val(localStorage.getItem('client-phone'));
        nameInputForm.val(localStorage.getItem('client-name'));
        formName.val(localStorage.getItem('client-name'));
        formPhone.val(localStorage.getItem('client-phone'));
        email.val(localStorage.getItem('client-email'));
        manufacture.val(localStorage.getItem('client-manufacture'));
        manufactureHidden.val(localStorage.getItem('client-manufacture'));
        phoneCode.val(localStorage.getItem('phone-code'));
    },

    phoneCodeChange: function (selector, countryCode = "ru", valid = false) {

        var phoneInputs = $(selector);
        var dataForPhoneInput = window.registration.countryCodeData[countryCode];

        $('.phone-code').html(dataForPhoneInput.code);

        phoneInputs.attr('placeholder', dataForPhoneInput.placeholder);
        //phoneInputs.inputmask(dataForPhoneInput.mask, {showMaskOnFocus: false, showMaskOnHover: false});
        //phoneInputs.rules('add', {minlengthPhone: dataForPhoneInput.numberCount});
        $('.icon-flag-phone').removeClass().addClass('icon-flag-phone phone-code-flag mx-1 ' + countryCode);
        if (valid) {
            phoneInputs.valid();
        }
        localStorage.setItem('client-country-code', countryCode);
    },

    checkmanufactureName: function () {
        var manufactureName = $('#manufacture_name');
        manufactureName.on('input', function () {
            var $this = $(this);
            var $delay = 500;
            if ($this.val() == '') {
                manufactureName.removeClass('preloader');
                $("#manufacture-name-label").removeClass('d-block').addClass('d-none');
            } else {
                manufactureName.addClass('preloader');
            }

            clearTimeout($this.data('timer'));

            $this.data('timer', setTimeout(function () {
                $this.removeData('timer');
                if ($this.val().length != 0) {
                    window.registration.sendManufacure($this.val())
                } else {
                    $("#manufacture-name-label").removeClass('d-block').addClass('d-none');
                }
            }, $delay));
        })
    },

    sendManufacure: function (manufactureName) {
        axios
            .post('/auth/registration/checkmanufacture', {
                manufacture_name: manufactureName
            })
            .then(response => {
                $('#manufactureNameLabel').html(response.data)
                localStorage.setItem('client-manufacture', response.data);
                $("#manufacture-name-label").removeClass('d-none').addClass('d-block');
                $('#manufacture_name').removeClass('preloader');
            })
    },

    selectCodePhone: function () {
        $('.phone-code-item').on('click', function () {
            window.registration.phoneCodeChange("#modal-phone", $(this).data('country'), true);
            window.registration.phoneCodeChange("#form-phone", $(this).data('country'), true);
        })

    },

    /*
    validate: function () {
        $.validator.addMethod("requiredPhone", function (value, element, param) {
            value = value.replace('+7 (___) ___ - __ - __');

            if (!this.depend(param, element)) {
                return "dependency-mismatch";
            }
            if (element.nodeName.toLowerCase() === "select") {
                var val = $(element).val();
                return val && val.length > 0;
            }
            if (this.checkable(element)) {
                return this.getLength(value, element) > 0;
            }
            return $.trim(value).length > 0;
        }, "Укажите номер телефона");


        $.validator.addMethod("minlengthPhone", function (value, element, param) {
            value = value.replace('+7', '');
            value = value.replace(/\s/g, '');
            value = value.replace(/-/g, '');
            value = value.replace(/_/g, '');

            var length = $.isArray(value) ? value.length : this.getLength($.trim(value), element);
            return this.optional(element) || length >= param;
        }, "Телефон должен быть не менее {0} символов");

        $.validator.addMethod("cyrillic", function (value, element, param) {
            return (value.search('[А-Яа-яЁё]') != -1) ? false : true;
        }, "Пароль не должен содержать кириллические символы");

        $.validator.addMethod("space", function (value, element, param) {
            return (value.search(' ') != -1) ? false : true;
        }, "Пароль не должен содержать пробелы");

        $("#try-form").validate({
            focusInvalid: false,
            errorClass: 'error',
            rules: {
                name: {
                    required: true,
                },
                phone: {
                    requiredPhone: true,
                    minlengthPhone: 10,
                }
            },
            messages: {
                name: "Напишите имя, чтобы знали как к вам обращаться",
            },
            submitHandler: function (form) {
                $('#registrationModal').modal('show');
            },
        });

        $("#step-1-form").validate({
            focusInvalid: false,
            errorClass: 'error',
            rules: {
                name: {
                    required: true,
                },
                phone: {
                    requiredPhone: true,
                    minlengthPhone: 10,
                },
                "manufacture_name": {
                    required: true,
                },
                email: {
                    required: true,
                    email: true,
                },
                password: {
                    cyrillic: true,
                    required: true,
                    minlength: 6,
                    space: true
                },
                contract: {
                    required: true,
                }
            },
            messages: {
                name: "Напишите имя, чтобы знали как к вам обращаться",
                "manufacture_name": "Введите название предприятия",
                email: {
                    required: "Проверьте адрес эл. почты, который вы написали",
                    email: "Неверный формат эл. почты",
                    remote: "Такой email уже существует"
                },
                password: {
                    minlength: "Напишите пароль минимум из 6 символов",
                    required: "Напишите пароль минимум из 6 символов",
                    cyrillic: "Пароль не должен содержать кириллические символы"
                },
                contract: "Без согласия нельзя продолжить регистрацию"
            },
            submitHandler: function () {
                window.registration.checkmanufactureName();
                window.registration.sendRegistrationData('#step-1-form');
            },
            errorPlacement: function (error, element) {
                error.each(function (index, item) {
                    if ($(item).attr("id") == "contract-error") {
                        $(item).appendTo($('#personalContractCheck').parent().parent())
                    } else {
                        $(item).appendTo($(element).parent())
                    }
                })
                ;
            }
        });

        $('#step-2-form').validate({
            focusInvalid: false,
            errorClass: 'error',
            rules: {
                buisnes_is_work: {
                    required: true,
                },
                manufacture_name_select: {
                    required: true,
                },
                role_in_company: {
                    required: true,
                },
            },
            messages: {
                buisnes_is_work: "Укажите статус",
                manufacture_name_select: "Укажите статус",
                role_in_company: "Укажите статус"
            },
            submitHandler: function () {
                window.registration.sendStep2('#step-2-form');
            },
        })

    },
    */

    sendRegistrationData: function (selector) {
        var formData = $(selector).serializeJSON();


        if ($('#manufactureNameLabel').html() != '') {
            formData.manufacture_name = $('#manufactureNameLabel').html();
        }

        $('#btn-step-one').children('.btn-text').addClass('d-none');
        $('#btn-step-one').children('.spinner-border').removeClass('d-none');
        $('#btn-step-one').prop('disabled', true);
        axios.post($(selector).attr('action'), {
            data: formData
        }).then(response => {
            $('#step-1-tab').tab('show');
            window.registration.clearInputs();
            localStorage.setItem('client-manufacture-id', response.data.manufacture_id);
        })
    },

    formDisableToggle: function (form) {

    },

    sendStep2: function (selector) {
        var formData = $(selector).serializeJSON();
        formData.manufacture_id = localStorage.getItem('client-manufacture-id');
        $('#go-account').children('.btn-text').addClass('d-none');
        $('#go-account').children('.spinner-border').removeClass('d-none');
        $('#go-account').prop('disabled', true);
        axios.post($(selector).attr('action'), {
            data: formData
        }).then(response => {
            var authData = response.data;
            window.registration.clearInputs();
            window.location.href = 'https://' + authData.subdomain + '.p.flylunch.ru/auth/token/' + authData.token;
        })
    },

    onInputEvent: function () {
        var phoneInputForm = $('#modal-phone'),
            nameInputForm = $('.modal-name'),
            formName = $('#form-name'),
            formPhone = $('#form-phone'),
            email = $('#email-modal'),
            manufacture = $('#manufacture_name'),

            formPhones = $('.phone-input');

        phoneInputForm.on('input', function () {
            localStorage.setItem('client-phone', window.registration.replacePhone(phoneInputForm.val()))
            formPhone.val(window.registration.replacePhone(phoneInputForm.val()));
        })
        nameInputForm.on('input', function () {
            localStorage.setItem('client-name', nameInputForm.val())
            formName.val(nameInputForm.val());
        })

        formName.on('input', function () {
            localStorage.setItem('client-name', formName.val());
            nameInputForm.val(formName.val());
        })

        formPhone.on('input', function () {
            localStorage.setItem('client-phone', window.registration.replacePhone(formPhone.val()));
            phoneInputForm.val(window.registration.replacePhone(formPhone.val()));
        })

        email.on('input', function () {
            localStorage.setItem('client-email', email.val());
        })

        manufacture.on('input', function () {
            localStorage.setItem('client-manufacture', manufacture.val());
        })

    },

    replacePhone: function (value) {
        value = value.replace('+7', '');
        value = value.replace(/\s/g, '');
        value = value.replace(/-/g, '');
        value = value.replace(/_/g, '');
        return value;
    },

    clearInputs: function () {
        var phoneInputForm = $('#modal-phone'),
            nameInputForm = $('.modal-name'),
            formName = $('#form-name'),
            formPhone = $('#form-phone'),
            email = $('#email-modal'),
            manufacture = $('#manufacture_name');

        phoneInputForm.val('');
        nameInputForm.val('');
        formName.val('');
        formPhone.val('');
        email.val('');
        manufacture.val('');

        localStorage.setItem('client-phone', '');
        localStorage.setItem('client-name', '');
        localStorage.setItem('client-name', '');
        localStorage.setItem('client-phone', '');
        localStorage.setItem('client-email', '');
        localStorage.setItem('client-manufacture', '');
    },

    targetsToggle: function () {
        $('#targets .target_show').on('click', function () {
            $('#targets .target_show').hide();
            $('#targets .target_close').show();
            $('#targets .target_content').removeClass('half-hidden')
        });
        $('#targets .target_close').on('click', function () {
            $('#targets .target_show').show();
            $('#targets .target_close').hide();
            $('#targets .target_content').addClass('half-hidden')
        });
    }

}.init();

var capabilities = {
    init: function () {
        var that = this;
        window.capabilities = that;
        $('.btn-activate').click(function () {
            $(this).parent().children("button").removeClass('active');
            $(this).addClass('active');
        })
        that.initCarouselIndicators();
    },
    initCarouselIndicators: function () {
        $(".buttons[data-target]").each(function (i, indicators) {
            var targetId = indicators.dataset.target;
            if (targetId != "") {
                var $carousel = $(targetId);
                $carousel.bind('slide.bs.carousel', function (e) {
                    var $targetSlide = $(e.relatedTarget);
                    var index = $targetSlide.index();
                    $('.buttons[data-target="' + targetId + '"] .btn-activate').removeClass('active')
                    $('.buttons[data-target="' + targetId + '"] .btn-activate:nth-child(' + (index + 1) + ')').addClass('active');
                });
            }
        });
    }
}.init();

